const DIGIT_PATTERN = /\d/;

export function getChangedDigitIndices(previous: string, next: string): number[] {
  if (previous === next) return [];

  if (previous.length !== next.length) {
    return next
      .split('')
      .map((char, index) => (DIGIT_PATTERN.test(char) ? index : -1))
      .filter((index) => index >= 0);
  }

  const changed: number[] = [];
  for (let index = 0; index < next.length; index += 1) {
    if (previous[index] !== next[index] && DIGIT_PATTERN.test(next[index])) {
      changed.push(index);
    }
  }

  return changed;
}
